// eslint-disable-next-line import/prefer-default-export
export const DUPLICATED_EXCEPTION_ID = 'duplicated';
